<template>
  <import-data-view type="accounts" title="Аккаунты"></import-data-view>
</template>

<script>
    import ImportDataView from '@/components/import/ImportDataView';

    export default {
        components: {
            ImportDataView,
        },
    };
</script>


// WEBPACK FOOTER //
// src/pages/ui/ImportAccounts.vue